import routeFactory from '../../../../../../../common/util/routeFactory';

export const firmDetailGridsRoutes = {
  customerCrmInvestorFirmSalesCoverageGrid:
    routeFactory.customerCrmInvestorFirmSalesCoverageGrid.routePath,
  customerCrmInvestorFirmInvestorContactsGrid:
    routeFactory.customerCrmInvestorFirmInvestorContactsGrid.routePath,
  sysAdminCrmInvestorFirmSalesCoverageGrid:
    routeFactory.sysAdminCrmInvestorFirmSalesCoverageGrid.routePath,
  sysAdminCrmInvestorFirmInvestorContactsGrid:
    routeFactory.sysAdminCrmInvestorFirmInvestorContactsGrid.routePath,
};
